<main>
  <div class="container-fluid">
    <h1 class="mt-4">Product Links Management</h1>
    <ol class="breadcrumb mb-4">
      <li class="breadcrumb-item active">Product Links Management</li>
    </ol>

    <div class="row">
      <div class="col">
        <button class="btn btn-primary" (click)="openProductLinkModal('')">Add Product Link</button>
        <button class="btn btn-success ml-2" (click)="openBulkAddModal()">Bulk Add</button>
        <button class="btn btn-danger ml-2" (click)="deleteSelected()" [disabled]="selectedCount === 0" title="Delete selected rows">
          Delete selected ({{ selectedCount }})
        </button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-4">
        <form>
          <input name="find" type="text" class="form-control" placeholder="Search product links..." [(ngModel)]="query.queryString"
                 (ngModelChange)="onSearchChange()">
        </form>
      </div>
      <div class="col-md-3">
        <select class="form-control" [(ngModel)]="query.merchantGroupId" (ngModelChange)="onMerchantGroupFilterChange()">
          <option value="">All Merchant Groups</option>
          <option *ngFor="let group of merchantGroups" [value]="group.id">{{group.name}}</option>
        </select>
      </div>
      <div class="col-md-2">
        <label class="mb-0 d-flex align-items-center">
          <input type="checkbox" [(ngModel)]="query.outOfStockOnly" (ngModelChange)="onOutOfStockFilterChange()" name="outOfStockOnly">
          <span class="ml-2">Out of stock only</span>
        </label>
      </div>
      <div class="col-md-2">
        <label class="mb-0 d-flex align-items-center">
          <input type="checkbox" [(ngModel)]="query.priceChangedOnly" (ngModelChange)="onPriceChangedFilterChange()" name="priceChangedOnly">
          <span class="ml-2">Price change only</span>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="table-responsive mt-3">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th style="width: 40px;">
                  <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll()" title="Select all on this page">
                </th>
                <th>Image</th>
                <th>Product Name</th>
                <th style="width: 160px;">Link</th>
                <th>Previous price</th>
                <th>Price</th>
                <th>In Stock</th>
                <th>Ship From</th>
                <th>Sold By</th>
                <th>Ship Time</th>
                <th>Last Crawled</th>
                <th>Team</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pl of queryResult.items">
                <td>
                  <input type="checkbox" [checked]="isSelected(pl)" (change)="toggleSelect(pl)" title="Select row">
                </td>
                <td>
                  <span class="product-img-wrap" *ngIf="pl.imageUrl">
                    <img [src]="pl.imageUrl" alt="Product" class="product-thumb"
                         onerror="this.src='data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'80\' height=\'80\'%3E%3Crect fill=\'%23ddd\' width=\'80\' height=\'80\'/%3E%3Ctext fill=\'%23999\' font-family=\'sans-serif\' font-size=\'14\' dy=\'10.5\' x=\'50%25\' y=\'50%25\' text-anchor=\'middle\'%3ENo Image%3C/text%3E%3C/svg%3E'">
                    <span class="product-img-full" *ngIf="pl.imageUrl">
                      <img [src]="pl.imageUrl" alt="Product full size">
                    </span>
                  </span>
                  <span *ngIf="!pl.imageUrl">-</span>
                </td>
                <td>{{pl.productName || '-'}}</td>
                <td>
                  <a [href]="pl.url" target="_blank" *ngIf="pl.url" class="product-link-text">{{getLinkText(pl.url)}}</a>
                  <span *ngIf="!pl.url">-</span>
                </td>
                <td>{{pl.previousPrice || '-'}}</td>
                <td>
                  <span>{{pl.price || '-'}}</span>
                  <ng-container *ngIf="getPriceDiff(pl) as diff">
                    <span *ngIf="diff.hasDiff" class="price-diff" [ngClass]="diff.isUp ? 'price-diff-up' : 'price-diff-down'">
                      <i *ngIf="diff.isUp" class="fas fa-arrow-up" aria-hidden="true"></i>
                      <i *ngIf="diff.isDown" class="fas fa-arrow-down" aria-hidden="true"></i>
                      {{diff.diffText}}
                    </span>
                  </ng-container>
                </td>
                <td>
                  <span class="badge" [ngClass]="pl.isInStock ? 'badge-success' : 'badge-danger'">
                    {{pl.isInStock ? 'Yes' : 'No'}}
                  </span>
                </td>
                <td>{{pl.shipFrom || '-'}}</td>
                <td>{{pl.soldBy || '-'}}</td>
                <td>{{pl.shipTime || '-'}}</td>
                <td>{{formatDate(pl.lastCrawledTime)}}</td>
                <td>{{pl.merchantGroup?.name || '-'}}</td>
                <td>
                  <button class="btn btn-primary btn-sm" (click)="openProductLinkModal(pl.id)" title="Edit">
                    <i class="fas fa-pen-square"></i>
                  </button>
                  <button class="btn btn-danger btn-sm ml-2" (click)="deleteProductLink(pl)" title="Delete">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="queryResult.items.length === 0">
                <td colspan="13" class="text-center">No product links found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="float-right mt-3">
      <app-pagination [(pageNumber)]="query.pageNumber" [pageSize]="query.pageSize" [totalItems]="queryResult.total"
                      (onPageChanged)="queryProductLinks($event)">
      </app-pagination>
    </div>
  </div>

  <ng-template #productLinkModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">
        <span *ngIf="productLinkDetail.id">Edit</span>
        <span *ngIf="!productLinkDetail.id">Create New</span> Product Link
      </h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form name="productLinkDetail">
        <div class="form-group row">
          <label class="col-3 col-form-label">URL *</label>
          <div class="col-9">
            <input type="text" class="form-control" [(ngModel)]="productLinkDetail.url" name="url" required placeholder="https://www.amazon.com/...">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">Product Name</label>
          <div class="col-9">
            <input type="text" class="form-control" [(ngModel)]="productLinkDetail.productName" name="productName">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">Image URL</label>
          <div class="col-9">
            <input type="text" class="form-control" [(ngModel)]="productLinkDetail.imageUrl" name="imageUrl">
            <img *ngIf="productLinkDetail.imageUrl" [src]="productLinkDetail.imageUrl" alt="Preview" 
                 style="max-width: 200px; max-height: 200px; margin-top: 10px; object-fit: contain;"
                 onerror="this.style.display='none'">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">In Stock</label>
          <div class="col-9">
            <input type="checkbox" [(ngModel)]="productLinkDetail.isInStock" name="isInStock">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">Price</label>
          <div class="col-9">
            <input type="text" class="form-control" [(ngModel)]="productLinkDetail.price" name="price">
          </div>
        </div>
        <div class="form-group row" *ngIf="productLinkDetail.previousPrice">
          <label class="col-3 col-form-label">Previous price</label>
          <div class="col-9">
            <span class="form-control-plaintext">{{productLinkDetail.previousPrice}}</span>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">Ship From</label>
          <div class="col-9">
            <input type="text" class="form-control" [(ngModel)]="productLinkDetail.shipFrom" name="shipFrom">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">Sold By</label>
          <div class="col-9">
            <input type="text" class="form-control" [(ngModel)]="productLinkDetail.soldBy" name="soldBy">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">Ship Time</label>
          <div class="col-9">
            <input type="text" class="form-control" [(ngModel)]="productLinkDetail.shipTime" name="shipTime">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-3 col-form-label">Merchant Group *</label>
          <div class="col-9">
            <select class="form-control" [(ngModel)]="productLinkDetail.merchantGroupId" name="merchantGroupId" required>
              <option value="">Select Merchant Group</option>
              <option *ngFor="let group of merchantGroups" [value]="group.id">{{group.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row" *ngIf="productLinkDetail.lastCrawledTime">
          <label class="col-3 col-form-label">Last Crawled</label>
          <div class="col-9">
            <span class="form-control-plaintext">{{formatDate(productLinkDetail.lastCrawledTime)}}</span>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveProductLink()">Save</button>
    </div>
  </ng-template>

  <ng-template #bulkAddModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Bulk Add Product Links</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form name="bulkAddForm">
        <div class="form-group">
          <label>Merchant Group *</label>
          <select class="form-control" [(ngModel)]="bulkAddData.merchantGroupId" name="merchantGroupId" required>
            <option value="">Select Merchant Group</option>
            <option *ngFor="let group of merchantGroups" [value]="group.id">{{group.name}}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Product Links (one URL per line) *</label>
          <textarea class="form-control" rows="10" [(ngModel)]="bulkAddData.urls" name="urls" 
                    placeholder="https://www.amazon.com/...&#10;https://www.amazon.com/...&#10;https://www.amazon.com/..." required></textarea>
          <small class="form-text text-muted">Enter one Amazon product URL per line. Each line will be treated as a separate product link.</small>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveBulkProductLinks()">Add All</button>
    </div>
  </ng-template>
</main>
